import { render, staticRenderFns } from "./AIChatBot.vue?vue&type=template&id=449e9804&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./AIChatBot.vue?vue&type=script&lang=js"
export * from "./AIChatBot.vue?vue&type=script&lang=js"
import style0 from "./AIChatBot.vue?vue&type=style&index=0&id=449e9804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449e9804",
  null
  
)

export default component.exports